import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowDownIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M7.33203 1V11.6667"
      id="Vector"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.332 7.66602L7.33203 11.666L3.33203 7.66602"
      id="Vector_2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9993 15H0.666016"
      id="Vector_3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
